import React, { FC } from 'react';

import { EmptyContent } from '@/shared/components/EmptyContent/EmptyContent';
import { mainRoute } from '@/scenarios/home/routes';

import { useI18n } from '../../hooks/useI18n';
import cart from '../../assets/cart.svg';

export const EmptyPurchases: FC = () => {
    const i18n = useI18n();

    return (
        <EmptyContent
            title={i18n('purchases_empty_title')}
            buttonText={i18n('purchases_empty_button')}
            location={mainRoute()}
            iconAlt={i18n('purchases_empty_icon_alt')}
            iconSrc={cart}
        />
    );
};
